import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nay2x5mkxs: FaireBrandEntity = {
  token: "b_nay2x5mkxs",
  type: "brand",
  name: "Genesis Holistic Health",
  avatarUrl:
    "https://cdn.faire.com/fastly/e2c025c093007c00ac3ef9646529efbfed63bf6ed3478e2855eea8eacabda722.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a6ce38e081277cc30ea998fdcb87925e043c1e7b48d74f8149d1ea31be283398.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e2c025c093007c00ac3ef9646529efbfed63bf6ed3478e2855eea8eacabda722.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a6ce38e081277cc30ea998fdcb87925e043c1e7b48d74f8149d1ea31be283398.png",
  location: "Springboro, OH, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "ABOUT GENESIS HOLISTIC HEALTH\n\nFounded in 2023 by a Board Certified Functional Diagnostic Nutritionist, at Genesis Holistic Health, we believe true wellness starts with restoring the balance you were designed to live in. Health isn’t just about treating symptoms — it’s about uncovering root causes, supporting the body’s natural rhythms, and empowering people to thrive in body, mind, and spirit.\n\nThat’s why we exist: to make the path to holistic health simple, compassionate, and accessible.\n\nFrom this belief flows everything we do. We create all-natural, organic products that work with — not against — your body. Each formula is thoughtfully crafted to offer safe, effective alternatives that bring real relief, drawing on both the wisdom of nature and modern nutritional science.\n\nOur commitment is to integrity at every step: carefully sourcing pure ingredients, blending them with care, and ensuring every product meets the highest standards of quality and efficacy.\n\nWhen you choose Genesis Holistic Health, you’re not just buying wellness products — you’re joining a mission to embrace health at its source, rediscover balance, and live fully well",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:15.520Z",
    importedBy: "entity-db-cli",
  },
};
